<script lang="ts" setup>
import type { VNode } from 'vue';
import { hasSlotContent } from '../../utils';
import style from './ob-action-list-item.module.scss';

defineSlots<{
  default?: () => VNode;
  leadingVisual?: () => VNode;
  trailingVisual?: () => VNode;
  description?: () => VNode;
}>();
</script>

<template>
  <span v-if="hasSlotContent($slots.leadingVisual)" :class="[style.leadingVisual]">
    <slot name="leadingVisual" />
  </span>
  <span :class="style.container">
    <span :class="style.label">
      <slot />
    </span>
    <span v-if="hasSlotContent($slots.description)" :class="style.description">
      <slot name="description" />
    </span>
  </span>
  <span v-if="hasSlotContent($slots.trailingVisual)" :class="[style.trailingVisual]">
    <slot name="trailingVisual" />
  </span>
</template>
